import { render, staticRenderFns } from "./BarChartAssigned.vue?vue&type=template&id=04c11358&"
import script from "./BarChartAssigned.vue?vue&type=script&lang=js&"
export * from "./BarChartAssigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports